export class Consts {
	public static ShellStoreName = 'ShellStore';
	public static FeatureToggleStoreName = 'FeatureToggleStore';
	public static CompanySoftwareOptionsName = 'CompanySoftwareOptionsStore';
	public static IosimSimulationInfoName = 'iosim-simulation-info';
	public static NavigationStore = 'NavigationStore';
	public static LabStore = 'LabStore';
	public static AccountManagementAppId = 'account-management-ui';
	public static AccountManagement = 'practice-management';
	public static wrapper = 'wrapper';
	public static AxiContainer = 'axi-container';

	public static Storage = {
		Settings: 'settings',
		ServerVersion: 'serverVersion',
		TransitionsStack: 'transitionsStack',
		Logo: 'logo',
		Region: 'region',
		AkitaStores: 'AkitaStores',
	};

	public static TablesIds = {
		PracticeUsers: 'practice-users-table',
		PracticeInvitations: 'practice-invitations-table'
	};

	public static GoogleApiAddressTypes = {
		Locality: 'locality',
		PostalCode: 'postal_code',
		Country: 'country',
		AdministrativeAreaLevel1: 'administrative_area_level_1'
	};

	public static HeaderKeys = {
		SelectedDoctorId: 'X-Doctor-ID',
		SelectedCompanyId: 'X-Company-ID',
		Authorization: 'Authorization',
		LogonAsId: 'X-LogonAs-ID',
	};

	public static SessionType = 'web';

	public static Resolution = {
		Mobile: 768
	};

	public static Enablers = {
		isCaseFlowManagementEnabled: 'isCaseFlowManagementEnabled',
		isShare3DPreviewEnabled: 'isShare3DPreviewEnabled'
	};

	public static Context = {
		CaseFlowManagement: 'CaseFlowManagement',
		Share3DPreview: 'Share3DPreview'
	};

	public static RefreshTokenPath = 'session/refresh?sessionId={0}&appId={1}';
	public static LogoutPath = 'authorize/logout';

	public static NavigationCommands = new Map<string, any[]>([
			['iosim', ['/', 'doctors', 'iosim-plus']]
	]);

	public static CookiesNames = {
		RETURNURL: 'RETURNURL',
		SWITCHREGIONURL: 'SWITCHREGIONURL',
	};
	public static readonly chatHubBIConsts = {
		OpenChatWindow: 'open new chat window',
	};
	public static readonly iteroChatHub = 'itero-chat-hub';	
}
